import { z } from "../zod.js";

// RFC 9457 problem+json envelope — the error shape of every endpoint (D-022).
// `code` is the stable machine key (UPPER_SNAKE, from each module's spec §5);
// `errors` carries field-level detail for validation failures.
export const Problem = z
  .object({
    // RFC 9457 `type` is a URI-reference (relative refs like /problems/x are
    // legal), so this is deliberately looser than z.url().
    type: z.string().min(1).default("about:blank"),
    title: z.string(),
    status: z.number().int().min(400).max(599),
    detail: z.string().optional(),
    instance: z.string().optional(),
    code: z
      .string()
      .regex(/^[A-Z][A-Z0-9_]*$/, "problem codes are UPPER_SNAKE")
      .optional(),
    request_id: z.string().optional(),
    errors: z
      .array(
        z.object({
          path: z.string(),
          code: z.string(),
          message_key: z.string(),
          params: z.record(z.string(), z.unknown()).optional(),
        }),
      )
      .optional(),
  })
  .openapi("Problem", {
    description:
      "RFC 9457 problem document. Stable machine-readable `code` values are defined per endpoint in the module specifications.",
  });

export type Problem = z.infer<typeof Problem>;
